import { module } from 'angular';

import { default as ChatAssistance } from './chat-assistance/chat-assistance.module.ajs';
import { default as Core } from './core/core.module.ajs';
import { default as Customer } from './customer/customer.module.ajs';
import { default as History } from './history/history.module.ajs';
import { default as Toolbox } from './toolbox/toolbox.module.ajs';

export default module('contact.commons', [ChatAssistance, Core, Customer, History, Toolbox]).name;
